import { merge } from 'lodash';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as safecosmeticDashboardTypes from './safecosmeticDashboardTypes';

const byId = handleActions(
  {
    [safecosmeticDashboardTypes.SAFECOSMETIC_DASHBOARD_LIST.SUCCESS]: (state, { payload }) => merge({}, state, payload.entities.safecosmeticDashboard),
  },
  {},
);

const allIds = handleActions(
  {
    [safecosmeticDashboardTypes.SAFECOSMETIC_DASHBOARD_LIST.SUCCESS]: (state, { payload }) => payload.result,
  },
  [],
);

export default combineReducers({
  byId,
  list: combineReducers({
    allIds,
  }),
});
